<template>
    <!-- Start Footer Area -->
    <footer class="footer-area bg-f7fafd">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <!--<div class="logo">
                            <a href="/">
                                <img src="../../assets/img/logo.png" alt="logo" />
                            </a>
                        </div>-->
                        <h3>Educating the Guess</h3>
                        <p>We're an initiative with researchers from RWTH Aachen University, Stanford University and TU Munich.</p>
                        <p>This work is part-funded by Deutsches Stiftungszentrum.</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget pl-5">
                        <h3>Team</h3>
                        <ul class="list">
                            <li><a href="https://www.linkedin.com/in/janauernhammer/">Jan Auernhammer</a></li>
                            <li><a href="https://www.linkedin.com/in/rubenconrad/">Ruben Conrad</a></li>
                            <li><a href="https://www.linkedin.com/in/felix-kuhn/">Felix Kuhn</a></li>
                            <li><a href="https://www.linkedin.com/in/clemens-repp/">Clemens Repp</a></li>
                            <!--<li><a href="#">Our Pricing</a></li>
    <li><a href="#">Latest News</a></li>-->
                        </ul>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Legal</h3>
                        <ul class="list">
                            <!--<li><a href="#">FAQ's</a></li>-->
                            <li><a href="/#/privacy">Privacy Policy</a></li>
                            <li><a href="/#/terms-conditions">Terms & Conditions</a></li>
                             <li><a href="/#/nachhaltigkeit">Test Nachhaltigkeit</a></li>
                            <li><a href="https://educating-the-guess.com/sitemap.xml">Sitemap</a></li>
                            <!-- <li><a href="mailto:felix.kuhn@stanford.edu">Contact Us</a></li>-->
                        </ul>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Contact us</h3>
                        
                        <ul class="footer-contact-info">
                            <!--<li><feather type="map-pin"></feather> 27 Division St, New York, NY 10002, USA</li>-->
                            <li><feather type="mail"></feather> Email: <a href="mailto:team@educating-the-guess.com">team@educating-the-guess.com</a></li>
                            <li><feather type="phone-call"></feather> Phone: <a href="tel:00491711293566">+49 171 1293566</a></li>
                        </ul>
                        <!--<ul class="social-links">
                            <li><a href="#" class="facebook"><feather type="facebook"></feather></a></li>
                            <li><a href="#" class="twitter"><feather type="twitter"></feather></a></li>
                            <li><a href="#" class="instagram"><feather type="instagram"></feather></a></li>
                            <li><a href="https://www.linkedin.com/in/felix-kuhn/" class="linkedin"><feather type="linkedin"></feather></a></li>
                        </ul>-->
                    </div>
                </div>

                <div class="col-lg-12 col-md-12">
                    <div class="copyright-area">
                        <p>Copyright &copy;2020 Felix Kuhn. All Rights Reserved</p>
                    </div>
                </div>
            </div>
        </div>

        <img src="../../assets/img/map.png" class="map" alt="map">
        <div class="shape1"><img src="../../assets/img/shape1.png" alt="shape"></div>
        <div class="shape8 rotateme"><img src="../../assets/img/shape2.svg" alt="shape"></div>
        <!-- <div class="go-top"><feather type="arrow-up"></feather></div> -->

        <back-to-top bottom="50px" right="50px">
            <div class="go-top"><feather type="arrow-up"></feather></div>
        </back-to-top>
    </footer>
    <!-- End Footer Area -->
</template>

<script>
import BackToTop from 'vue-backtotop'
export default {
    name: 'Footer',
    components: { BackToTop }
}
</script>